import { Assets } from '@helpers/Constants/Assets';
import { OnBoardCompletionProps } from '@helpers/Models';

export const OnBoardingCompletion: React.FC<OnBoardCompletionProps> = ({
  onAction,
}) => {
  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
      onClick={onAction}
    >
      <div
        className="bg-white w-full max-w-md rounded-lg shadow-lg p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex flex-col justify-center items-center text-center">
          <img src={Assets.ONBOARD_COMPLETION} alt="Onboarding Complete" />
          <h1 className="mt-2 font-semibold text-[48px] text-[#27214D]">
            Congratulations!
          </h1>
          <span className="text-[#808080A6] text-lg mt-3">
            Onboarding Completed
          </span>
          <button
            type="button"
            className="text-white bg-primary p-4 mt-5 w-[50%]"
            onClick={onAction}
          >
            Let’s Start
          </button>
        </div>
      </div>
    </div>
  );
};
